import { Calendar, User } from 'lucide-react';
import { Card, CardBody } from '@/components/ui/Card';
import { Avatar } from '@/components/ui/Avatar';
import { StatusBadge } from '@/components/ui/Badge';
import { formatDate } from '@/utils/dates';
import { getPatientFullName, getPatientInitials, type Patient } from '@/types/patient';

interface PatientInfoProps {
  patient: Patient;
}

export function PatientInfo({ patient }: PatientInfoProps) {
  const fullName = getPatientFullName(patient);
  const initials = getPatientInitials(patient);

  return (
    <Card>
      <CardBody>
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-start">
          <Avatar initials={initials} size="xl" />

          <div className="flex-1 text-center sm:text-left">
            <div className="flex flex-col items-center gap-2 sm:flex-row">
              <h2 className="text-xl font-semibold text-foreground">{fullName}</h2>
              <StatusBadge status={patient.status} />
            </div>

            <div className="mt-4 grid gap-3 text-sm sm:grid-cols-2">
              <div className="flex items-center justify-center gap-2 text-muted sm:justify-start">
                <User className="h-4 w-4" />
                <span>{patient.username}</span>
              </div>

              {patient.dateOfBirth && (
                <div className="flex items-center justify-center gap-2 text-muted sm:justify-start">
                  <Calendar className="h-4 w-4" />
                  <span>Born {formatDate(patient.dateOfBirth)}</span>
                </div>
              )}
            </div>

            <div className="mt-4 flex flex-wrap justify-center gap-6 border-t border-border pt-4 sm:justify-start">
              <div>
                <p className="text-2xl font-bold text-foreground">
                  {patient.totalActivities}
                </p>
                <p className="text-sm text-muted">Total Activities</p>
              </div>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
